import React, { useEffect, useRef } from "react";

import { LoadingSpinner } from "../../pages/Dashboard/components/School/pages/SchoolList";

const Table = ({
  data,
  heading,
  footer,
  description,
  actions,
  searchBox,
  className,
  csv_name,
  loading = false,
}: any) => {
  const [csv_link, set_csv_link] = React.useState("");
  const refs: any = useRef<any>([]);
  // const { user } = useContext(dashboardContext);

  useEffect(() => {
    // console.log({ refs });
    if (data && data.length > 0) {
      let csvContent =
        "data:text/csv;charset=utf-8," +
        (data[0].join(",") +
          "\n" +
          refs?.current
            .map((r?: any) =>
              r
                ? [].slice.call(r?.children).map((c: any) => {
                    return JSON.stringify(c?.innerText).replace("\u20b9", "");
                  })
                : ""
            )
            .map((e: any) => (e ? e.join(",") : ""))
            .join("\n"));
      var encodedUri = encodeURI(csvContent);
      set_csv_link(encodedUri);
    }
  }, [data]);
  // enum Access {
  //   SUPER = "super",
  //   ALL_ACCESS = "all_access",
  //   MANAGEMENT = "management",
  //   STAFF = "staff",
  // }

  // const []
  return (
    <div className="flex flex-col w-full">
      <div className="table w-full shadow p-5 rounded-lg my-2 text-[#1e1b59]">
        <div className="flex flex-col md:flex-row md:items-center justify-between w-full mb-4">
          <div className="w-full md:w-auto mb-4 md:mb-0">
            <div className="text-lg font-semibold mt-3 mb-2">{heading}</div>
            <div className="text-sm text-gray-500 mb-3">{description}</div>
          </div>

          {/* Actions and CSV download */}
          <div
            className={
              "flex flex-col md:flex-row md:items-center justify-end space-y-2 md:space-y-0 md:space-x-2 w-full " +
              className
            }
          >
            {actions}

            <a
              download={typeof heading !== "string" ? csv_name : heading}
              href={csv_link}
              className="focus:outline-none outline-none"
            >
              <button className="bg-[#6F6AF8] text-white px-5 h-10 rounded-lg">
                Download CSV
              </button>
            </a>
          </div>
        </div>

        {searchBox && <div className="mb-6">{searchBox}</div>}

        {loading ? (
          <LoadingSpinner />
        ) : !data || data.length <= 1 ? (
          <div className="text-center py-8 text-gray-500">
            No data available
          </div>
        ) : (
          <>
            {/* Table content */}
            <div
              ref={(e) => (refs.current[0] = e)}
              className={`grid grid-cols-${
                data[0]?.length || 1
              } grid-header p-3 font-semibold bg-[#ECEDFB] rounded-t-lg text-violet-900`}
            >
              {data[0]?.map((item: any, index: number) => {
                return (
                  <div className="text-center" key={`header-${index}`}>
                    {item}
                  </div>
                );
              })}
            </div>

            {data.slice(1).map((row: any, key: any) => {
              return (
                <div
                  ref={(e) => (refs.current[key] = e)}
                  className={`grid grid-cols-${
                    data[0]?.length || 1
                  } grid-body items-center p-3 my-2 odd:bg-[#ECEDFB] even:bg-white odd:border-none even:border border-[#ECEDFB] rounded-lg`}
                  key={`row-${key}`}
                >
                  {row.map((item: any, index: number) => {
                    return (
                      <div
                        className="text-center relative"
                        key={`cell-${key}-${index}`}
                      >
                        {item}
                      </div>
                    );
                  })}
                </div>
              );
            })}

            {footer}
          </>
        )}
      </div>
    </div>
  );
};

export default Table;
